import React from "react";
import DictionaryEntry from "./DictionaryEntry";
import styles from "./diccionario.module.css";

export default function DictionaryList({ items }) {
  if (!items || items.length === 0) {
    return <p className={styles.empty}>No hay resultados.</p>;
  }
  return (
    <section className={styles.grid}>
      {items.map((it) => (
        <DictionaryEntry key={it.term} item={it} />
      ))}
    </section>
  );
}
